import { Component, Vue } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';

import WithRender from './contract-duration.component.html';
import { DDCalendarDate } from '@/models/common';
import { ConractData } from '../contract-data/contract-data.component';
import { EventBus, Events } from '@/event-bus';
import CancelRequestComponent from '@/components/dialog/cancel-request.component.vue';
import DropDownCalendarComponent from '@/components/dropDownCalendar.vue';
import ExternalService from '@/services/external';
import UserService from '@/services/user';
import { moduleProxy } from '@/store';

@WithRender
@Component({
  components: {
    DropDownCalendarComponent,
  },
  diProvide: [
    ExternalService,
    UserService,
  ],
})
export default class ContractDuration extends Vue {
  @Inject(ExternalService) public externalService!: ExternalService;
  @Inject(UserService) public userService!: UserService;
  contractStartDate: DDCalendarDate = { isGregorian: false } as DDCalendarDate;
  contractEndDate: DDCalendarDate = { isGregorian: false } as DDCalendarDate;
  startDateKey = '';

  created() {
    // Subscribe to an event.
    EventBus.$on(Events.Request.ConfirmCancelRequestEvent, () => {
      moduleProxy.Contract.clearContract();
      this.$router.push({ name: 'issueContract' });
    });
  }

  mounted() {
    const contractData = moduleProxy.Contract.getContract;
    if (contractData && contractData.startDate) {
      this.contractStartDate = contractData.startDate;
      this.contractEndDate = contractData.endDate;
      this.startDateKey = this.contractStartDate.gregDate;
    }
  }

  beforeDestroy() {
    // Unsubscribe from an event.
    EventBus.$off(Events.Request.ConfirmCancelRequestEvent);
  }

  onStartDateChanged(date: DDCalendarDate) {
    this.contractStartDate = date;
    this.contractEndDate = { isGregorian: false } as DDCalendarDate;
  }

  onEndDateChangedDate(date: DDCalendarDate) {
    if (!this.contractStartDate) {
      return;
    }

    this.contractEndDate = date;
  }

  previousStep() {
    this.$router.push({ name: 'partners' });
  }

  async nextStep(): Promise<void> {
    const isValid = await (this.$refs.formRef as any).validate();

    if (!isValid) return;

    if ((this.contractStartDate?.gregDate || this.contractStartDate?.hijriDate)
      && (this.contractEndDate?.gregDate || this.contractEndDate?.hijriDate)) {
      const contractDate = { startData: this.contractStartDate, endDate: this.contractEndDate } as ConractData;
      moduleProxy.Contract.setContractDate({ startDate: contractDate.startData, endDate: contractDate.endDate });
      this.$router.push({ name: 'contractData' });
    }
  }

  /**
   * Initiate cancel request process.
   */
  onCancel(): void {
    // Publish an event.
    EventBus.$emit(Events.Dialog.OpenDialogEvent, CancelRequestComponent);
  }
}
